import {
    exportarSuplidoresGrid,
    useBuscarGridSuplidoresDashboard,
    useBuscarSuplidoresAutoComplete,
} from "../../Scripts/Services/cxp-service.js";
import React, {useEffect, useState} from 'react';

import {
  AutoComplete,
  SelectButton,
  Dropdown,
  addLocale,
  Button,
  Column,
  DataTable,
  Calendar,
  ProgressSpinner,
  FilterMatchMode,
  FilterOperator,
  InputNumber,
  locale,
  Message,
  Row,
  ColumnGroup,
} from 'primereact';
import {createPortal} from "react-dom";
import Exportar from "../../../Commons/Scripts/Componentes/Exportar/Exportar";
import ToolTip from "../../../Commons/Scripts/Componentes/ToolTip/Tooltip";
import {SvgComponent} from "../../../Commons/Scripts/Componentes";
import { Dropdown as Dp, Nav } from 'react-bootstrap';
import {useTheme} from "../../../Commons/Scripts/Hooks";
export const GridCxp = () => {
  addLocale("es", {
    firstDayOfWeek: 1,
    showMonthAfterYear: true,
    dayNames: [
      "domingo",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "sábado",
    ],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
    monthNames: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    monthNamesShort: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
    today: "Hoy",
    clear: "Limpiar",
    equals: "Igual a",
    notEquals: "Diferente a",
    lt: "Menor a",
    lte: "Menor o igual a",
    gt: "Mayor a ",
    gte: "Mayor o igual a",
    is: "Is",
    isNot: "Is Not",
    before: "Before",
    after: "After",
    apply: "Aplicar",
    matchAll: "Coincidir todo",
    matchAny: "Coincidir cualquiera",
    addRule: "Agregar condicion",
    removeRule: "Quitar condicion",
  });
  const {theme} = useTheme();
  const [showExportar, setShowExportar] = useState(false);
  const monedaPredeterminada = window.monedaPredeterminada;
  const colorPrimario = window.colorPrimario;
  const [fechasGrid, setFechasGrid] = React.useState(null);
  // tabla
  const [tiendas, setTiendas] = React.useState([]);
  const [periodoGrid, setPeriodoGrid] = React.useState("mensual");
  const [filtros, setFiltros] = React.useState(null);
  const [cargandoData, setCargandoGrid] = React.useState(true);
  const [gridWhere, setGridWhere] = React.useState({
    where: {
      EsAscendente: false,
      EsOrdernable: true,
      OrderBy: "FacturasMonto",
      IndiceDePagina: 0,
      esFecha: false,
      periodo: periodoGrid,
      TiendaNombresList: tiendas,
    },
  });
  const { data: tiendasGrid, error: errorTiendasGrid } =
    useBuscarGridSuplidoresDashboard(gridWhere);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [lazyState, setlazyState] = React.useState({
    first: 0,
    rows: 10,
    page: 0,
    sortField: "CantidadTotalVentas",
    sortOrder: -1,
    filters: filtros,
  });
  const onPage = (event) => {
    const newWhere = {
      where: {
        ...gridWhere.where,
        fechaInicio: fechasGrid?.[0] ?? null,
        fechaFin: fechasGrid?.[1] ?? null,
        IndiceDePagina: event.page,
      },
    };
    setGridWhere(newWhere);
    setlazyState(event);
    setCargandoGrid(true);
  };
  const onSort = (event) => {
    const newWhere = {
      where: {
        ...gridWhere.where,
        fechaInicio: fechasGrid?.[0] ?? null,
        fechaFin: fechasGrid?.[1] ?? null,
        EsAscendente: event.sortOrder == 1,
        OrderBy: event.sortField,
      },
    };
    setGridWhere(newWhere);
    setlazyState(event);
    setCargandoGrid(true);
  };
  const onFilter = (event) => {
    const filtros = event.filters;
    setlazyState(event);
    const newWhere = {
      where: {
        ...gridWhere.where,
        fechaInicio: fechasGrid?.[0] ?? null,
        fechaFin: fechasGrid?.[1] ?? null,
        SuplidoresNombresList: filtros.Nombre.value,
        FacturasMontoFiltros: filtros.FacturasMonto.constraints.map((e) => ({
          [e.value]: e.matchMode,
        })),
        FacturasCantidadFiltros: filtros.FacturasCantidad.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        FacturasPromedioFiltros: filtros.FacturasPromedio.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        FacturaPendienteMontoFiltros:
          filtros.FacturaPendienteMonto.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        FacturaPendienteCantidadFiltros:
          filtros.FacturaPendienteCantidad.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        FacturasVencidasMontoFiltros:
          filtros.FacturasVencidasMonto.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        FacturasVencidasCantidadFiltros:
          filtros.FacturasVencidasCantidad.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        FacturasDescuentoMontoFiltros:
          filtros.FacturasDescuentoMonto.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        FacturasDescuentoCantidadFiltros:
          filtros.FacturasDescuentoCantidad.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        FacturaDescuentoPromedioFiltros:
          filtros.FacturaDescuentoPromedio.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        CalidadCreditoFiltros: filtros.CalidadCredito.constraints.map((e) => ({
          [e.value]: e.matchMode,
        })),
        TasaMorosidadFiltros: filtros.TasaMorosidad.constraints.map((e) => ({
          [e.value]: e.matchMode,
        })),
        TasaImpagosFiltros: filtros.TasaImpagos.constraints.map((e) => ({
          [e.value]: e.matchMode,
        })),
        NotaCreditoMontoFiltros: filtros.NotaCreditoMonto.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        NotaCreditoCantidadFiltros: filtros.NotaCreditoCantidad.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        NotaCreditoPromedioFiltros: filtros.NotaCreditoPromedio.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        NotaDebitoMontoFiltros: filtros.NotaDebitoMonto.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        NotaDebitoCantidadFiltros: filtros.NotaDebitoCantidad.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        NotaDebitoPromedioFiltros: filtros.NotaDebitoPromedio.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),

        AnticipoMontoFiltros: filtros.AnticipoMonto.constraints.map((e) => ({
          [e.value]: e.matchMode,
        })),
        AnticipoCantidadFiltros: filtros.AnticipoCantidad.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        AnticipoPromedioFiltros: filtros.AnticipoPromedio.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),

        OrdenesCompraCantidadFiltros:
          filtros.OrdenesCompraCantidad.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        OrdenesCompraMontoFiltros: filtros.OrdenesCompraMonto.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        OrdenesCompraPromedioFiltros:
          filtros.OrdenesCompraPromedio.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),

        PagosContadoMontoFiltros: filtros.PagosContadoMonto.constraints.map(
          (e) => ({
            [e.value]: e.matchMode,
          })
        ),
        PagosContadoCantidadFiltros:
          filtros.PagosContadoCantidad.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        PagosContadoPromedioFiltros:
          filtros.PagosContadoPromedio.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
      },
    };
    setGridWhere(newWhere);
    setCargandoGrid(true);
  };
  const borrarFiltros = () => {
    const newWhere = {
      where: {
        ...gridWhere.where,
        fechaInicio: fechasGrid?.[0] ?? null,
        fechaFin: fechasGrid?.[1] ?? null,
        SuplidoresNombresList: null,
        FacturasMontoFiltros: null,
        FacturasCantidadFiltros: null,
        FacturasPromedioFiltros:null,
        FacturaPendienteMontoFiltros:null,
        FacturaPendienteCantidadFiltros:null,
        FacturasVencidasMontoFiltros:null,
        FacturasVencidasCantidadFiltros:null,
        FacturasDescuentoMontoFiltros:null,
        FacturasDescuentoCantidadFiltros:null,
        FacturaDescuentoPromedioFiltros:null,
        CalidadCreditoFiltros: null,
        TasaMorosidadFiltros: null,
        TasaImpagosFiltros: null,
        NotaCreditoMontoFiltros: null,
        NotaCreditoCantidadFiltros:null,
        NotaCreditoPromedioFiltros: null,
        NotaDebitoMontoFiltros: null,
        NotaDebitoCantidadFiltros: null,
        NotaDebitoPromedioFiltros: null,

        AnticipoMontoFiltros:null,
        AnticipoCantidadFiltros: null,
        AnticipoPromedioFiltros: null,
        OrdenesCompraCantidadFiltros:null,
        OrdenesCompraMontoFiltros: null,
        OrdenesCompraPromedioFiltros:null,
        PagosContadoMontoFiltros: null,
        PagosContadoCantidadFiltros:null,
        PagosContadoPromedioFiltros: null,
      },
    };
    setGridWhere(newWhere);
    setCargandoGrid(true);
    initFiltros();
  };
  const initFiltros = () => {
    setFiltros({
      FacturasMonto: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      FacturasCantidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      FacturasPromedio: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      FacturaPendienteMonto: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      FacturaPendienteCantidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      FacturasVencidasMonto: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      FacturasVencidasCantidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      FacturasDescuentoMonto: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      FacturasDescuentoCantidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      FacturaDescuentoPromedio: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      TasaMorosidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      TasaImpagos: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      CalidadCredito: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      NotaCreditoMonto: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      NotaCreditoCantidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      NotaCreditoPromedio: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      NotaDebitoMonto: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      NotaDebitoCantidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      NotaDebitoPromedio: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      AnticipoMonto: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      AnticipoCantidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      AnticipoPromedio: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      OrdenesCompraMonto: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      OrdenesCompraCantidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      OrdenesCompraPromedio: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      PagosContadoMonto: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      PagosContadoCantidad: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      PagosContadoPromedio: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        ],
      },
      Nombre: {
        value: null,
        matchMode: FilterMatchMode.IN,
      },
    });
  };
  const montosFiltroTemplate = (options) => {
    return (
      <InputNumber
        value={options.value}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        prefix={monedaPredeterminada}
        locale="en-US"
        minFractionDigits={2}
      />
    );
  };
  const tasasFiltroTemplate = (options) => {
    return (
      <InputNumber
        value={options.value}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        suffix="%"
      />
    );
  };
  const CantidadesFiltroTemplate = (options) => {
    return (
      <InputNumber
        value={options.value}
        onChange={(e) => options.filterCallback(e.value, options.index)}
      />
    );
  };
  const NombreFiltroTemplate = (options) => {
    return (
      <AutoComplete
        pt={{
          panel: { style: { width: "400px" } },
        }}
        onClick={(e) => autoCompleteRef.current.search(e, "", "dropdown")}
        ref={autoCompleteRef}
        emptyMessage="No hay resultados disponibles"
        showEmptyMessage="true"
        inputId="ac"
        value={options.value}
        multiple
        suggestions={dataFiltrada}
        completeMethod={buscarTiendas}
        placeholder="Buscar Suplidores"
        onChange={(e) => options.filterCallback(e.value)}
        style={{ width: "400px" }}
      />
    );
  };
  //multiLookup
  const autoCompleteRef = React.useRef(null);
  const [where, setWhere] = React.useState({ where: {} });
  const { data } = useBuscarSuplidoresAutoComplete(where);
  const [dataFiltrada, setDataFiltrada] = React.useState(null);
  const [cargando, setCargando] = React.useState(true);
  const buscarTiendas = (event) => {
    setWhere({ where: { Criterio: event.query, CantidadPorPagina: 1000 } });
  };

  //filtro periodos
  const [periodo, setPeriodo] = React.useState(1);
  const periodos = [
    { name: "Actual", value: 1 },
    { name: "Anterior", value: 2 },
    { name: "Otro", value: 3 },
  ];
  const [value, setValue] = React.useState(3);
  const [periodosPredifinidos, setPeriodosPredifinidos] = React.useState([]);
  const actual = [
    { name: "Hoy", value: 1 },
    { name: "Esta Semana", value: 2 },
    { name: "Este Mes", value: 3 },
    { name: "Este Trimestre", value: 4 },
    { name: "Este Año", value: 5 },
  ];
  const anterior = [
    { name: "Ayer", value: 6 },
    { name: "Semana Anterior", value: 7 },
    { name: "Mes Anterior", value: 8 },
    { name: "Trimestre Anterior", value: 9 },
    { name: "Año Anterior", value: 10 },
  ];
  function handleChange(value) {
    setValue(value);
    setCargandoGrid(true);
    let periodo;
    switch (value) {
      case 1:
        periodo = "diario";
        break;
      case 2:
        periodo = "semanal";
        break;
      case 3:
        periodo = "mensual";
        break;
      case 4:
        periodo = "trimestral";
        break;
      case 5:
        periodo = "anual";
        break;
      case 6:
        periodo = "ayer";
        break;
      case 7:
        periodo = "semana anterior";
        break;
      case 8:
        periodo = "mes anterior";
        break;
      case 9:
        periodo = "trimestre anterior";
        break;
      case 10:
        periodo = "ano anterior";
        break;
    }
    setPeriodoGrid(periodo);
    const newWhere = {
      where: {
        ...gridWhere.where,
        periodo: periodo,
        esFecha: false,
      },
    };
    setGridWhere(newWhere);
  }
  const [dates, setDates] = React.useState(null);
  let today = new Date();
  const [verRangoDeFechas, setVerRangoDeFechas] = React.useState(false);

  function setFechas() {
    setValue(null);
    const fechasFormateadas = dates.map((date) => formatDate(date));
    setFechasGrid(fechasFormateadas);
    const newWhere = {
      where: {
        ...gridWhere.where,
        fechaInicio: formatDate(dates[0]),
        fechaFin: formatDate(dates[1]),
        esFecha: true,
      },
    };
    setGridWhere(newWhere);
    setCargandoGrid(true);
  }
  function formatDate(date) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    return day + "/" + month + "/" + year;
  }
  const matchModes = [
    {
      label: "Mayor o igual a",
      value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
    },
    { label: "Menor o igual a", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
  ];
  const header = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div className="p-component">
          <Button
            type="button"
            icon="pi pi-filter-slash"
            label="Limpiar Filtros"
            outlined
            onClick={borrarFiltros}
            id="quitarFiltros"
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            flexDirection: "column",
            alignItems: "center",
            minWidth: "50%",
          }}
        >
          <div style={{ width: "40%", marginBottom: "5px" }}>
            <Dropdown
              value={periodo}
              onChange={(e) => setPeriodo(e.value)}
              options={periodos}
              optionLabel="name"
            />
          </div>

          {verRangoDeFechas ? (
            <div>
              <Calendar
                maxDate={today}
                placeholder="Rango de Fechas"
                dateFormat="dd/mm/yy"
                value={dates}
                selectionMode="range"
                locale="es"
                onChange={(e) => setDates(e.value)}
              />
            </div>
          ) : (
            <SelectButton
              value={value}
              onChange={(e) => handleChange(e.value)}
              optionLabel="name"
              options={periodosPredifinidos}
            />
          )}
        </div>
          <div>
              <Dp as={Nav.Item}>
                  <Dp.Toggle
                      as={Nav.Link}
                      id="Dp-company-switch"
                      className="buttonHover"
                      onClick={openExportar}
                  >
                      <ToolTip placement="left" message="Exportar">
                          <SvgComponent
                              iconName="export"
                              fill={theme.color1}
                          />
                      </ToolTip>
                  </Dp.Toggle>
              </Dp>
          </div>
      </div>
    );
  };
  const colmunasHeaderGruop = [
    //Facturas
    {
      field: "FacturasMonto",
      header: "Monto total",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    {
      field: "FacturasCantidad",
      header: "Cantidad",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    {
      field: "FacturasPromedio",
      header: "Promedio",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    //Facturas Pendientes
    {
      field: "FacturaPendienteMonto",
      header: "Monto total",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    {
      field: "FacturaPendienteCantidad",
      header: "Cantidad",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    //Facturas Vencidas
    {
      field: "FacturasVencidasMonto",
      header: "Monto total",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    {
      field: "FacturasVencidasCantidad",
      header: "Cantidad",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    // Descuentos
    {
      field: "FacturasDescuentoMonto",
      header: "Monto total",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    {
      field: "FacturasDescuentoCantidad",
      header: "Cantidad",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    {
      field: "FacturaDescuentoPromedio",
      header: "Promedio",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    // Tasas
    {
      field: "CalidadCredito",
      header: "Calidad de Credito",
      dataType: "numeric",
      filterElement: tasasFiltroTemplate,
    },
    {
      field: "TasaMorosidad",
      header: "Tasa de Morosidad",
      dataType: "numeric",
      filterElement: tasasFiltroTemplate,
    },
    {
      field: "TasaImpagos",
      header: "Tasa de Impagos",
      dataType: "numeric",
      filterElement: tasasFiltroTemplate,
    },
    // Notas de Credito
    {
      field: "NotaCreditoMonto",
      header: "Monto total",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    {
      field: "NotaCreditoCantidad",
      header: "Cantidad",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    {
      field: "NotaCreditoPromedio",
      header: "Promedio",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    // Notas de Debito
    {
      field: "NotaDebitoMonto",
      header: "Monto total",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    {
      field: "NotaDebitoCantidad",
      header: "Cantidad",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    {
      field: "NotaDebitoPromedio",
      header: "Promedio",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    //Anticpos
    {
      field: "AnticipoMonto",
      header: "Monto total",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    {
      field: "AnticipoCantidad",
      header: "Cantidad",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    {
      field: "AnticipoPromedio",
      header: "Promedio",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    // Ordenes de Compra
    {
      field: "OrdenesCompraMonto",
      header: "Monto total",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    {
      field: "OrdenesCompraCantidad",
      header: "Cantidad",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    {
      field: "OrdenesCompraPromedio",
      header: "Promedio",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    // PagosContado
    {
      field: "PagosContadoMonto",
      header: "Monto total",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
    {
      field: "PagosContadoCantidad",
      header: "Cantidad",
      dataType: "numeric",
      filterElement: CantidadesFiltroTemplate,
    },
    {
      field: "PagosContadoPromedio",
      header: "Promedio",
      dataType: "numeric",
      filterElement: montosFiltroTemplate,
    },
  ];
  const colmunasDataTable = [
    { field: "_FacturasMontoConSimbolo" },
    { field: "FacturasCantidad" },
    { field: "_FacturasPromedioConSimbolo" },

    { field: "_FacturaPendinteMontoConSimbolo" },
    { field: "FacturaPendienteCantidad" },

    { field: "_FacturasVencidasMontoConSimbolo" },
    { field: "FacturasVencidasCantidad" },

    { field: "_FacturaDescuentoMontoConSimbolo" },
    { field: "FacturaDescuentoCantidad" },
    { field: "_FacturasVencidasMontoConSimbolo" },

    { field: "_CalidadCreditoConSimbolo" },
    { field: "_TasaMorosidadPorciento" },
    { field: "_TasaImpagosPorciento" },

    { field: "_NotaCreditoMontoConSimbolo" },
    { field: "NotaCreditoCantidad" },
    { field: "_NotaCreditoPromedioConSimbolo" },

    { field: "_NotaDebitoMontoConSimbolo" },
    { field: "NotaDebitoCantidad" },
    { field: "_NotaDebitoPromedioConSimbolos" },

    { field: "_AnticipoMontoConSimbolo" },
    { field: "AnticipoCantidad" },
    { field: "_AnticipoPromedioConSimbolo" },

    { field: "_OrdenComprasMontoConSimbolo" },
    { field: "OrdenesCompraCantidad" },
    { field: "_OrdenCompraPromedioConSimbolo" },

    { field: "_PagosContadoMontoConSimbolo" },
    { field: "PagosContadoCantidad" },
    { field: "_PagosContadoPromedioConSimbolo" },
  ];
  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column colSpan={2} />
        <Column header="Facturas" colSpan={3} />
        <Column header="Facturas Pendientes" colSpan={2} />
        <Column header="Facturas Vencidas" colSpan={2} />
        <Column header="Descuentos" colSpan={3} />
        <Column header="Tasas" colSpan={3} />
        <Column header="Notas de Credito" colSpan={3} />
        <Column header="Notas de Debito" colSpan={3} />
        <Column header="Anticpos" colSpan={3} />
        <Column header="Ordenes de Compra" colSpan={3} />
        <Column header="Pagos de Contado" colSpan={3} />
      </Row>
      <Row>
        <Column
          style={{ textAlign: "right" }}
          sortable
          field="IdSec"
          header="ID"
        />
        <Column
          style={{ minWidth: "15rem" }}
          sortable
          field="Nombre"
          header="Suplidor"
          showFilterMatchModes={false}
          filter
          filterField="Nombre"
          filterElement={NombreFiltroTemplate}
          pt={{
            filterMenuButton: { className: "p-component" },
            filterButtonbar: { className: "test" },
          }}
        />
        {colmunasHeaderGruop.map((col, i) => (
          <Column
            style={{ minWidth: "5rem" }}
            pt={{
              filterMenuButton: { className: "p-component" },
              filterButtonbar: { className: "test" },
            }}
            sortable
            field={col.field}
            header={col.header}
            filter
            sortField={col.field}
            filterField={col.field}
            filterElement={col.filterElement}
            dataType={col.dataType}
            showFilterOperator={false}
            filterMatchModeOptions={matchModes}
          />
        ))}
      </Row>
    </ColumnGroup>
  );
    const openExportar = () => {
        setShowExportar(true);
    };
  // useEffect
  React.useEffect(() => {
    locale("es");
    initFiltros();
  }, []);
  React.useEffect(() => {
    if (data) {
      let _tiendasFiltradas = [];
      _tiendasFiltradas = data.Resultados.map((e) => {
        return e.text;
      });
      setDataFiltrada(_tiendasFiltradas);
    }
  }, [data]);
  React.useEffect(() => {
    if (tiendasGrid && !errorTiendasGrid) {
      setTotalRecords(tiendasGrid.total);
      setCargando(false);
      setCargandoGrid(false);
    } else if (tiendasGrid) {
      setTotalRecords(tiendasGrid.total);
      setCargando(false);
      setCargandoGrid(false);
    }
  }, [tiendasGrid]);
  React.useEffect(() => {
    if (dates) {
      if (dates[0] !== null && dates[1] !== null) {
        setFechas();
      }
    }
  }, [dates]);
  React.useEffect(() => {
    if (periodo == 1) {
      setPeriodosPredifinidos(actual);
      setVerRangoDeFechas(false);
    } else if (periodo == 2) {
      setPeriodosPredifinidos(anterior);
      setVerRangoDeFechas(false);
    } else {
      setVerRangoDeFechas(true);
    }
  }, [periodo]);
  React.useEffect(() => {
    setlazyState({
      ...lazyState,
      filters: filtros,
    });
  }, [filtros]);

  return (
    <div className="new-p-table">
      {cargando ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ProgressSpinner />
        </div>
      ) : (
        <>
            {showExportar && createPortal(
                <Exportar
                    PROPIEDADES_EXPORTAR={[
                        {value: "IdSec", label: "Id"},
                        {value: "Nombre", label: "Suplidor"},
                        {value: "FacturasMonto", label: "Monto Facturas"},
                        {value: "FacturasCantidad", label: "Cantidad Facturas"},
                        {value: "FacturasPromedio", label: "Promedio Facturas"},
                        {value: "FacturaPendienteMonto", label: "Monto Facturas Pendientes"},
                        {value: "FacturaPendienteCantidad", label: "Cantidad Facturas Pendientes"},
                        {value: "FacturasVencidasMonto", label: "Monto Facturas Vencidas"},
                        {value: "FacturasVencidasCantidad", label: "Cantidad Facturas Vencidas"},
                        {value: "FacturasDescuentoMonto", label: "Monto Facturas Descuentos"},
                        {value: "FacturasDescuentoCantidad", label: "Cantidad Facturas Descuentos"},
                        {value: "FacturaDescuentoPromedio", label: "Promedio Facturas Descuentos"},
                        {value: "CalidadCredito", label: "Calidad de Credito"},
                        {value: "TasaMorosidad", label: "Tasa de Morosidad"},
                        {value: "TasaImpagos", label: "Tasa de Impagos"},
                        {value: "NotaCreditoMonto", label: "Monto Notas de Credito"},
                        {value: "NotaCreditoCantidad", label: "Cantidad Notas de Credito"},
                        {value: "NotaCreditoPromedio", label: "Promedio Notas de Credito"},
                        {value: "NotaDebitoMonto", label: "Monto Notas de Debito"},
                        {value: "NotaDebitoCantidad", label: "Cantidad Notas de Debito"},
                        {value: "NotaDebitoPromedio", label: "Promedio Notas de Debito"},
                        {value: "AnticipoMonto", label: "Monto Anticpos"},
                        {value: "AnticipoCantidad", label: "Cantidad Anticpos"},
                        {value: "AnticipoPromedio", label: "Promedio Anticpos"},
                        {value: "OrdenesCompraMonto", label: "Monto Ordenes de Compra"},
                        {value: "OrdenesCompraCantidad", label: "Cantidad Ordenes de Compra"},
                        {value: "OrdenesCompraPromedio", label: "Promedio Ordenes de Compra"},
                        {value: "PagosContadoMonto", label: "Monto Pagos de Contado"},
                        {value: "PagosContadoCantidad", label: "Cantidad Pagos de Contado"},
                        {value: "PagosContadoPromedio", label: "Promedio Pagos de Contado"},
                    ]}
                    where={{...gridWhere.where}}
                    showExportar={showExportar}
                    setShowExportar={setShowExportar}
                    exportarCallBack={exportarSuplidoresGrid}
                >
                </Exportar>,
                window.parent.document.querySelector("#sidebarContainer")
            )}
          <div>
            {errorTiendasGrid && (
              <Message
                severity="warn"
                text={errorTiendasGrid?.Mensaje}
                style={{ width: "100%", marginBottom: "10px" }}
              />
            )}
          </div>
          <DataTable
            showGridlines
            headerColumnGroup={headerGroup}
            header={header}
            onFilter={onFilter}
            filters={lazyState.filters}
            value={tiendasGrid.suplidores}
            lazy
            first={lazyState.first}
            rows={25}
            loading={cargandoData}
            paginator
            totalRecords={totalRecords}
            onPage={onPage}
            onSort={onSort}
            sortField={lazyState.sortField}
            sortOrder={lazyState.sortOrder}
            tableStyle={{ minWidth: "50rem" }}
            stripedRows
            size="small"
            emptyMessage="No hay resultados disponibles."
            resizableColumns
            columnResizeMode="expand"
            pt={{
              paginator: {
                pageButton: "p-component",
                nextPageButton: "p-component",
                lastPageButton: "p-component",
                prevPageButton: "p-component",
                firstPageButton: "p-component",
              },
            }}
          >
            <Column field="IdSec" style={{ textAlign: "right" }} />
            <Column field="Nombre" />
            {colmunasDataTable.map((col, i) => (
              <Column field={col.field} style={{ textAlign: "right" }} />
            ))}
          </DataTable>
        </>
      )}
    </div>
  );
};